import dynamic from 'next/dynamic';

import React from "react";
const Icon = dynamic(() => import('@/components/ui/Icon'), { ssr: false });
import Link from "next/link";
import "react-tooltip/dist/react-tooltip.css";

function Button({
  text,
  type = "button",
  isLoading,
  disabled,
  className = "bg-primary-500 text-white",
  children,
  icon,
  loadingClass = "unset-classname",
  iconPosition = "left",
  iconClass = "text-[20px]",
  link,
  dataTooltipId,
  onClick,
  div,
  dataTestId,
}) {
  return (
    <>
      {!link && !div && (
        <button
          data-testid={dataTestId}
          type={type}
          onClick={(e) => {
            if (!disabled && !isLoading) {
              onClick?.(e); // Only trigger onClick if the button is not disabled and not loading
            }
          }}
          data-tooltip-id={dataTooltipId}
          className={`btn btn inline-flex justify-center ${
            isLoading ? " pointer-events-none" : ""
          } ${disabled ? " opacity-40 cursor-not-allowed" : ""} ${className}`}
        >
          {/* if has children and not loading*/}
          {children && !isLoading && children}

          {/* if no children and  loading*/}
          {!children && !isLoading && (
            <span className="flex items-center">
              {/* if has icon */}
              {icon && (
                <span
                  data-testid="icon-no-link-no-div"
                  className={`${
                    text && iconPosition === "right"
                      ? "order-1 ml-2 rtl:mr-2"
                      : " "
                  } ${
                    text && iconPosition === "left" ? "mr-2 rtl:ml-2" : ""
                  } ${iconClass}`}
                >
                  <Icon icon={icon} />
                </span>
              )}
              <span>{text}</span>
            </span>
          )}

          {/* if loading*/}
          {isLoading && (
            <>
              <svg
                className={`animate-spin ltr:-ml-1 ltr:mr-3 rtl:-mr-1 rtl:ml-3 h-5 w-5 ${loadingClass}`}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                role="img"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
              {text || "Loading ..."}
            </>
          )}
        </button>
      )}
      {!link && div && (
        <div
          onClick={onClick}
          className={`btn btn inline-flex justify-center ${
            isLoading ? " pointer-events-none" : ""
          } ${disabled ? " opacity-40 cursor-not-allowed" : ""} ${className}`}
          role="button"
          data-testid={dataTestId}
        >
          {/* if has children and not loading*/}
          {children && !isLoading && children}

          {/* if no children and  loading*/}
          {!children && !isLoading && (
            <span className="flex items-center">
              {/* if has icon */}
              {icon && (
                <span
                  data-testid="icon-no-link-div"
                  className={`${
                    iconPosition === "right" ? "order-1 ltr:ml-2 rtl:mr-2" : " "
                  } ${
                    text && iconPosition === "left" ? "ltr:mr-2 rtl:ml-2" : ""
                  } ${iconClass}`}
                >
                  <Icon icon={icon} />
                </span>
              )}
              <span>{text}</span>
            </span>
          )}

          {/* if loading*/}
          {isLoading && (
            <>
              <svg
                className={`animate-spin ltr:-ml-1 ltr:mr-3 rtl:-mr-1 rtl:ml-3 h-5 w-5 ${loadingClass}`}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                role="img"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
              {text || "Loading ..."}
            </>
          )}
        </div>
      )}
      {link && !div && (
        <Link
          data-testid={dataTestId}
          href={link}
          className={`btn btn inline-flex justify-center ${
            isLoading ? " pointer-events-none" : ""
          } ${disabled ? " opacity-40 cursor-not-allowed" : ""} ${className}`}
        >
          {/* if has children and not loading*/}
          {children && !isLoading && children}

          {/* if no children and  loading*/}
          {!children && !isLoading && (
            <span className="flex items-center">
              {/* if has icon */}
              {icon && (
                <span
                  data-testid="icon-link-no-div"
                  className={`${
                    iconPosition === "right" ? "order-1 ltr:ml-2 rtl:mr-2" : " "
                  } ${
                    text && iconPosition === "left" ? "ltr:mr-2 rtl:ml-2" : ""
                  } ${iconClass}`}
                >
                  <Icon icon={icon} />
                </span>
              )}
              <span>{text}</span>
            </span>
          )}

          {/* if loading*/}
          {isLoading && (
            <>
              <svg
                className={`animate-spin ltr:-ml-1 ltr:mr-3 rtl:-mr-1 rtl:ml-3 h-5 w-5 ${loadingClass}`}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                role="img"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
              {text || "Loading ..."}
            </>
          )}
        </Link>
      )}
    </>
  );
}

export default Button;